import CancelButton from "Common/Components/Buttons/CancelButton";
import { DeleteButton } from "Common/Components/Buttons/DeleteButton";
import PrimarySubmitButton from "Common/Components/Buttons/PrimarySubmitButton";
import FileUploadInput from "Common/Components/FileUploadInput/FileUploadInput";
import NewFileUploadInput from "components/FilePreview/FileInputPreview";
import FilePreview from "components/FilePreview/FilePreview";
import FilePreview2 from "components/FilePreview/FilePreview2";
import { useEffect } from "react";
import { Col, Form, Row } from "react-bootstrap";

interface KYCDetailsProps {
  goToTab: (tab: string) => void;
  kycDetailsFormik: any;
  other_details: any;
  set_other_details: any;
  otherfileInputRef: any;
  otherDocumentTableFormik: any;
}

const KYCDetails: React.FC<KYCDetailsProps> = ({
  goToTab,
  kycDetailsFormik,
  other_details,
  set_other_details,
  otherfileInputRef,
  otherDocumentTableFormik,
}) => {
  const handleDeleteOtherDocuments = (index: number) => {
    const updated_other_Documents = other_details.filter(
      (_: any, i: number) => i !== index
    );
    set_other_details(updated_other_Documents);
  };

  useEffect(() => {
    // Auto-set KYC approved based on PAN and CIN details
    const { is_pan_details, is_cin_details } = kycDetailsFormik.values;
    if (is_pan_details && is_cin_details) {
      kycDetailsFormik.setFieldValue("is_kyc_approved", true);
    } else {
      kycDetailsFormik.setFieldValue("is_kyc_approved", false);
    }
  }, [
    kycDetailsFormik.values.is_pan_details,
    kycDetailsFormik.values.is_cin_details,
  ]);

  console.log("other_details : ", other_details);
  return (
    <>
      <Form>
        <div className="mt-4">
          {/* KYC Approved Checkbox */}
          <div className="form-check mb-3" style={{ flexDirection: "row" }}>
            <input
              className="form-check-input"
              type="checkbox"
              id="is_kyc_approved"
              checked={kycDetailsFormik?.values?.is_kyc_approved}
              onChange={(e) => {
                kycDetailsFormik.setFieldValue(
                  "is_kyc_approved",
                  e.target.checked,
                );
              }}
              style={{
                width: "16px",
                height: "16px",
                borderRadius: "0px",
                backgroundColor: kycDetailsFormik?.values?.is_kyc_approved
                  ? "#0CBA91"
                  : "",
                borderColor: kycDetailsFormik?.values?.is_kyc_approved
                  ? "#0CBA91"
                  : "",
              }}
              disabled
            />
            <label className="form-check-label">KYC Approved</label>
          </div>

          {/* PAN Details Checkbox */}
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="is_pan_details"
              checked={kycDetailsFormik?.values?.is_pan_details}
              onChange={(e) => {
                kycDetailsFormik.setFieldValue(
                  "is_pan_details",
                  e.target.checked,
                );
              }}
              style={{
                width: "16px",
                height: "16px",
                borderRadius: "0px",
                backgroundColor: kycDetailsFormik?.values?.is_pan_details
                  ? "#0CBA91"
                  : "",
                borderColor: kycDetailsFormik?.values?.is_pan_details
                  ? "#0CBA91"
                  : "",
              }}
            />
            <label className="form-check-label" htmlFor="is_pan_details">
              PAN Details
            </label>
          </div>

          {/* PAN Details Form Fields */}
          {kycDetailsFormik?.values?.is_pan_details && (
            <Row className="mb-3">
              <Col xs={12} md={4} lg={4}>
                <Form.Label style={{ fontWeight: 600 }}>
                  PAN No. <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  placeholder="Enter PAN No. "
                  id="pan_document_name"
                  name="pan_document_name"
                  value={kycDetailsFormik.values.pan_document_name}
                  onChange={kycDetailsFormik.handleChange}
                  onBlur={kycDetailsFormik.handleBlur}
                  isInvalid={
                    !!(
                      kycDetailsFormik.touched.pan_document_name &&
                      kycDetailsFormik.errors.pan_document_name
                    )
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {kycDetailsFormik.errors.pan_document_name}
                </Form.Control.Feedback>
              </Col>

              <Col xs={12} md={4} lg={4}>
                <NewFileUploadInput
                  label="PAN Document"
                  name="pan_document"
                  required={kycDetailsFormik?.values?.is_pan_details}
                  formik={kycDetailsFormik}
                />
              </Col>
            </Row>
          )}

          {/* GST Details Checkbox */}
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="is_gst_details"
              checked={kycDetailsFormik?.values?.is_gst_details}
              onChange={(e) => {
                kycDetailsFormik.setFieldValue(
                  "is_gst_details",
                  e.target.checked,
                );
              }}
              style={{
                width: "16px",
                height: "16px",
                borderRadius: "0px",
                backgroundColor: kycDetailsFormik?.values?.is_gst_details
                  ? "#0CBA91"
                  : "",
                borderColor: kycDetailsFormik?.values?.is_gst_details
                  ? "#0CBA91"
                  : "",
              }}
            />
            <label className="form-check-label" htmlFor="is_gst_details">
              GST Details
            </label>
          </div>

          {/* GST Details Form Fields */}
          {kycDetailsFormik?.values?.is_gst_details && (
            <Row className="mb-3">
              <Col xs={12} md={4} lg={4}>
                <Form.Label style={{ fontWeight: 600 }}>
                  GST No. <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  placeholder="Enter  GST No."
                  id="gst_document_name"
                  name="gst_document_name"
                  value={kycDetailsFormik.values.gst_document_name}
                  onChange={kycDetailsFormik.handleChange}
                  onBlur={kycDetailsFormik.handleBlur}
                  isInvalid={
                    !!(
                      kycDetailsFormik.touched.gst_document_name &&
                      kycDetailsFormik.errors.gst_document_name
                    )
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {kycDetailsFormik.errors.gst_document_name}
                </Form.Control.Feedback>
              </Col>

              <Col xs={12} md={4} lg={4}>
                <NewFileUploadInput
                  label="GST Document"
                  name="gst_document"
                  required={kycDetailsFormik?.values?.is_gst_details}
                  formik={kycDetailsFormik}
                />
              </Col>
            </Row>
          )}

          {/* CIN Details Checkbox */}
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="is_cin_details"
              checked={kycDetailsFormik?.values?.is_cin_details}
              onChange={(e) => {
                kycDetailsFormik.setFieldValue(
                  "is_cin_details",
                  e.target.checked,
                );
              }}
              style={{
                width: "16px",
                height: "16px",
                borderRadius: "0px",
                backgroundColor: kycDetailsFormik?.values?.is_cin_details
                  ? "#0CBA91"
                  : "",
                borderColor: kycDetailsFormik?.values?.is_cin_details
                  ? "#0CBA91"
                  : "",
              }}
            />
            <label className="form-check-label" htmlFor="is_cin_details">
              Corporate Identification Number(CIN) Details
            </label>
          </div>

          {/* CIN Details Form Fields */}
          {kycDetailsFormik?.values?.is_cin_details && (
            <Row className="mb-3">
              <Col xs={12} md={4} lg={4}>
                <Form.Label style={{ fontWeight: 600 }}>
                  CIN No. <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  placeholder="Enter CIN No."
                  id="cin_document_name"
                  name="cin_document_name"
                  value={kycDetailsFormik.values.cin_document_name}
                  onChange={kycDetailsFormik.handleChange}
                  onBlur={kycDetailsFormik.handleBlur}
                  isInvalid={
                    !!(
                      kycDetailsFormik.touched.cin_document_name &&
                      kycDetailsFormik.errors.cin_document_name
                    )
                  }
                />
                <Form.Control.Feedback type="invalid">
                  {kycDetailsFormik.errors.cin_document_name}
                </Form.Control.Feedback>
              </Col>

              <Col xs={12} md={4} lg={4}>
                <NewFileUploadInput
                  label="CIN Document"
                  name="cin_document"
                  required={kycDetailsFormik?.values?.is_cin_details}
                  formik={kycDetailsFormik}
                />
              </Col>
            </Row>
          )}

          {/* Other Details Checkbox */}
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              id="is_other_details"
              checked={kycDetailsFormik?.values?.is_other_details}
              onChange={(e) => {
                kycDetailsFormik.setFieldValue(
                  "is_other_details",
                  e.target.checked
                );
              }}
              style={{
                width: "16px",
                height: "16px",
                borderRadius: "0px",
                backgroundColor: kycDetailsFormik?.values?.is_other_details
                  ? "#0CBA91"
                  : "",
                borderColor: kycDetailsFormik?.values?.is_other_details
                  ? "#0CBA91"
                  : "",
              }}
            />
            <label className="form-check-label" htmlFor="is_other_details">
              Other Details
            </label>
          </div>

          {/* Other Details Form Fields */}
          {kycDetailsFormik?.values?.is_other_details && (
            <>
              <h5 className="fw-bold mt-3">Other Documents</h5>
              <Row className="mb-3 gy-3">
                <Col xs={12} md={4}>
                  <Form.Group controlId="document_type" className="mb-0">
                    <Form.Label className="fw-semibold">
                      Document Type <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      id="document_type"
                      name="document_type"
                      placeholder="Enter Document Type"
                      value={otherDocumentTableFormik.values.document_type}
                      onChange={otherDocumentTableFormik.handleChange}
                      onBlur={otherDocumentTableFormik.handleBlur}
                      isInvalid={
                        !!(
                          otherDocumentTableFormik.touched.document_type &&
                          otherDocumentTableFormik.errors.document_type
                        )
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {otherDocumentTableFormik.errors.document_type}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <Form.Group controlId="document_number" className="mb-0">
                    <Form.Label className="fw-semibold">
                      Document Number <span className="text-danger">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      id="document_number"
                      name="document_number"
                      placeholder="Enter Document Number"
                      value={otherDocumentTableFormik.values.document_number}
                      onChange={otherDocumentTableFormik.handleChange}
                      onBlur={otherDocumentTableFormik.handleBlur}
                      isInvalid={
                        !!(
                          otherDocumentTableFormik.touched.document_number &&
                          otherDocumentTableFormik.errors.document_number
                        )
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {otherDocumentTableFormik.errors.document_number}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col xs={12} md={4}>
                  <NewFileUploadInput
                    label="Document"
                    name="document_file"
                    required={kycDetailsFormik?.values?.is_other_details}
                    formik={otherDocumentTableFormik}
                  />
                </Col>
              </Row>
              <CancelButton
                onClick={() => otherDocumentTableFormik.handleSubmit()}
                showConfirmation={false}
                label="+ Add Document"
                className="mb-3"
              />

              {other_details.length > 0 && (
                <div className="mt-4">
                  <h6 className="fw-bold mb-3">Added Other Documents</h6>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "12px",
                    }}
                  >
                    {other_details?.map((document: any, index: number) => (
                      <div
                        key={index}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          padding: "12px 16px",
                          backgroundColor: "#f9f9f9",
                          borderRadius: "4px",
                          border: "1px solid #e0e0e0",
                        }}
                      >
                        <div style={{ flex: 1 }}>
                          <p
                            style={{
                              margin: 0,
                              fontSize: "0.875rem",
                              color: "#333",
                              fontWeight: "600",
                              marginBottom: "4px",
                            }}
                          >
                            <strong>Document {index + 1}</strong>
                          </p>
                          <p
                            style={{
                              margin: 0,
                              fontSize: "0.875rem",
                              color: "#333",
                              marginBottom: "4px",
                            }}
                          >
                            {document.document_type}
                          </p>
                          <p className="mb-1">
                            <FilePreview2
                              file={
                                document?.document_url ||
                                document?.document_file
                              }
                            />
                          </p>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              gap: "4px",
                            }}
                          >
                            <span
                              style={{ fontSize: "0.875rem", color: "#666" }}
                            >
                              {document?.document_number}
                            </span>
                          </div>
                        </div>
                        <DeleteButton
                          onClick={() => handleDeleteOtherDocuments(index)}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </>
          )}
        </div>

        {/* Navigation Buttons */}
        <div className="d-flex flex-wrap justify-content-center gap-3 mt-5">
          <PrimarySubmitButton
            type="button"
            label="Prev"
            onClick={() => goToTab("supplier")}
            className="px-4 mb-2"
          />
          <PrimarySubmitButton
            type="button"
            label="Next"
            onClick={() => kycDetailsFormik.handleSubmit()}
            className="px-4 mb-2"
          />
        </div>
      </Form>
    </>
  );
};

export default KYCDetails;
